export enum Api {
  academy = 'academy',
  account = 'account',
  accounts = 'accounts',
  activation_link = 'activation-link',
  active = 'active',
  active_scans = 'active-scans',
  activity = 'activity',
  activityLogs = 'activityLogs',
  lastTested = 'lastTested',
  add = 'add',
  add_scan_points = 'add-scan-points',
  admin = 'admin',
  advanced_scan = 'advanced-scan',
  aggregated_report = 'aggregated-report',
  ai = 'ai',
  all = 'all',
  all_ids = 'all_ids',
  amp_api_key = 'amp-api-key',
  monitoring_analytics = 'monitoring-analytics',
  api = 'api',
  apps = 'apps',
  approve = 'approve',
  archive = 'archive',
  assign_users = 'assign_users',
  assignees = 'assignees',
  attachmentId = 'attachmentId',
  attachments = 'attachments',
  automaticValidation = 'automatic-validation',
  attribution = 'attribution',
  archivable = 'archivable',
  auditType = 'auditType',
  audit_rules = 'audit-rules',
  audits = 'audits',
  auth = 'auth',
  authenticated = 'authenticated',
  automation = 'automation',
  available = 'available',
  availableIdpGroups = 'available-idp-groups',
  avatar = 'avatar',
  bulk = 'bulk',
  cancel = 'cancel',
  category = 'category',
  callback = 'callback',
  categories = 'categories',
  changePassword = 'change-password',
  changeEmails = 'change-emails',
  chat = 'chat',
  clientSearchTerm = 'clientSearchTerm',
  clients = 'clients',
  command = 'command',
  commentId = 'commentId',
  comments = 'comments',
  commonFindings = 'common-findings',
  commonFindingId = 'commonFindingId',
  company = 'company',
  complete = 'complete',
  component_report = 'component-report',
  config = 'config',
  configureEntities = 'configureEntities',
  configureFields = 'configFields',
  configureJson = 'configJson',
  console = 'console',
  consumer_key = 'consumer-key',
  cookie_policy = 'cookie-policy',
  connect_browser_extension = 'connect-browser-extension',
  count = 'count',
  countries = 'countries',
  create = 'create',
  createDesignRule = 'create-design-rule',
  createWorkspace = 'create-workspace',
  createNewPassword = 'createNewPassword',
  createToken = 'createToken',
  createOAuth2AuthorizationUrl = 'createOAuth2AuthorizationUrl',
  create_new_password = 'create-new-password',
  conformance = 'conformance',
  cuet_evaluations = 'cuet-evaluations',
  current = 'current',
  custom_audit_rules = 'custom-audit-rules',
  custom_severities = 'custom-severities',
  custom_reports = 'custom-reports',
  customLabels = 'custom-labels',
  customLabelId = 'customLabelId',
  dashboard = 'dashboard',
  data = 'data',
  dataId = 'dataId',
  deactivate = 'deactivate',
  default = 'default',
  deletable = 'deletable',
  designReviewProjects = 'design-review-projects',
  designReviewProjectId = 'designReviewProjectId',
  designReviewPages = 'design-review-pages',
  designReviewPageId = 'designReviewPageId',
  designReviewFindings = 'design-review-findings',
  designReviewFindingId = 'designReviewFindingId',
  designReviewFindingKey = 'designReviewFindingKey',
  designReviewFindingCategory = 'designReviewFindingCategory',
  designReviewFindingCommentId = 'designReviewFindingCommentId',
  designReviewFindingType = 'designReviewFindingType',
  designReviewRules = 'design-review-rules',
  designReviewRuleId = 'designReviewRuleId',
  details = 'details',
  devices = 'devices',
  digitalPropertyId = 'digitalPropertyId',
  digital_properties = 'digital-properties',
  digital_property = 'digital-property',
  digital_property_type = 'digital-property-type',
  digitalproperty = 'digitalproperty',
  digital_property_limit_state = 'digital-property-limit-state',
  digitalPropertyMetrics = 'digital-property-metrics',
  digitalAssetSettings = 'digital-asset-settings',
  dismiss = 'dismiss',
  dismissFindings = 'dismiss-findings',
  restoreFindings = 'restore-findings',
  documentId = 'documentId',
  documentation = 'documentation',
  documents = 'documents',
  domain = 'domain',
  download = 'download',
  downloadToken = 'downloadToken',
  duplicate = 'duplicate',
  edit = 'edit',
  editDesignRule = 'edit-design-rule',
  entities = 'entities',
  email = 'email',
  emailLookup = 'email-lookup',
  errors = 'errors',
  e2e = 'e2e',
  e2e_feature_flag_overrides = 'feature-flag-overrides',
  e2e_fme_flag_overrides = 'fme-flag-overrides',
  excludeGroupIds = 'excludeGroupIds',
  failedTasks = 'failed-tasks',
  force_password_reset = 'force-password-reset',
  favourite = 'favourite',
  flag = 'flag',
  evaluation_rules = 'evaluation-rules',
  evaluations = 'evaluations',
  event = 'event',
  existingKeyValues = 'existing-key-values',
  exists = 'exists',
  export = 'export',
  exclude_monitoring = 'exclude_monitoring',
  exclude_history = 'exclude_history',
  ext = 'ext',
  externalId = 'externalId',
  file = 'file',
  fileId = 'fileId',
  files = 'files',
  findings = 'findings',
  findingId = 'findingId',
  finishAuthorization = 'finishAuthorization',
  flawId = 'flawId',
  flaws = 'flaws',
  filter_options = 'filter-options',
  findingRules = 'finding-rules',
  issueId = 'issueId',
  forbidden = '403',
  generate_api_key = 'generate-api-key',
  generate_encryption_key = 'generate-encryption-key',
  generation = 'generation',
  golden = 'golden',
  apiKeyName = 'apiKeyName',
  generate_browser_extension_key = 'generate-browser-extension-key',
  groupId = 'groupId',
  group_mappings = 'group_mappings',
  idpGroupId = 'idpGroupId',
  mappingId = 'mappingId',
  groups = 'groups',
  Groups = 'Groups',
  guidelines = 'guidelines',
  hasHistoryUpdates = 'has-history-updates',
  home = 'home',
  id = 'id',
  impactful = 'impactful',
  insights = 'insights',
  instance = 'instance',
  instanceId = 'instanceId',
  integrations = 'integrations',
  internal = 'internal',
  internal_users = 'internal-users',
  invite = 'invite',
  isDuplicated = 'is-duplicated',
  issueKey = 'issueKey',
  issueType = 'issueType',
  issueTypes = 'issueTypes',
  issueFields = 'issueFields',
  issueTypeId = 'issueTypeId',
  issue_tracking = 'issue-tracking',
  issues = 'issues',
  issueIntegration = 'issueIntegration',
  issueIntegrationConnectionId = 'issueIntegrationConnectionId',
  issueIntegrationStatuses = 'issue-integration-statuses',
  issue_integration_connection = 'issue-integration-connection',
  issue_integration_connection_config = 'issue-integration-connection-config',
  issue_integration_status_mapping = 'issue-integration-status-mapping',
  issue_integration_projects = 'issue-integration-projects',
  issueIntegrationProjectId = 'issueIntegrationProjectId',
  jobFunction = 'job-function',
  jobIndustries = 'job-industries',
  jobTitles = 'job-titles',
  keyId = 'keyId',
  keys = 'keys',
  latest = 'latest',
  latest_scan = 'latest-scan',
  latest_scans = 'latest-scans',
  latest_version = 'latest-version',
  list = 'list',
  libraries = 'libraries',
  libraryId = 'libraryId',
  library = 'library',
  locale_id = 'locale',
  locales = 'locales',
  login = 'login',
  loginOrganizationRedirection = 'login-organization-redirection',
  logout = 'logout',
  logs = 'logs',
  manage_roles = 'manage-roles',
  manage_users = 'manage-users',
  manual = 'manual',
  manualAuditIssue = 'manualAuditIssue',
  manualAuditIssueId = 'manualAuditIssueId',
  manualEvaluationId = 'manualEvaluationId',
  manual_audit = 'manual-audit',
  testGuides = 'test-guides',
  testGuideId = 'testGuideId',
  manual_audit_issues_by_severity = 'manual-audit-issues-by-severity',
  manual_audit_top_criteria = 'manual-audit-top-criteria',
  manual_evaluations = 'manual-evaluations',
  manual_requests = 'manual-requests',
  manual_request_id = 'manual_request_id',
  manual_results = 'manual-results',
  linked_property = 'linked-property',
  manual_upload_file = 'manual-upload-file',
  ai_testing = 'ai-testing',
  manualFindings = 'manual-findings',
  markAsViewed = 'markAsViewed',
  mark_rule_as_false_positive = 'mark-rule-as-false-positive',
  master_library = 'master-library',
  master_libraries = 'master-libraries',
  matchComponent = 'matchComponent',
  matchComponentId = 'matchComponentId',
  match_components = 'match-components',
  knowledgeBase = 'knowledge-base',
  mcp = 'mcp',
  me = 'me',
  milestones = 'milestones',
  widgetDefinitions = 'widget-definitions',
  customFields = 'custom-fields',
  mobile = 'mobile',
  mobile_apps = 'mobile-apps',
  mobile_app_sessions = 'mobile-app-sessions',
  mobileAppsId = 'mobileAppsId',
  mobile_app_report = 'mobile-app-report',
  mobile_engine = 'mobile-engine',
  mobile_sdk = 'mobile-sdk',
  version_manifest = 'version-manifest',
  all_mobile_scans = 'all-mobile-scans',
  mobile_scans = 'mobile-scans',
  mobile_emulator_scans = 'mobile-emulator-scans',
  mobile_testing_emulator = 'mobile-testing-emulator',
  mobile_manual_evaluations = 'mobile-manual-evaluations',
  mobileManualEvaluationId = 'mobileManualEvaluationId',
  mobile_screens = 'mobile-screens',
  mobileScreenId = 'mobileScreenId',
  monitoring = 'monitoring',
  monitoringSettings = 'monitoring-settings',
  move = 'move',
  my = 'my',
  myTasks = 'my-tasks',
  names = 'names',
  next_scheduled_scan = 'next-scheduled-scan',
  not_found = '404',
  oauth = 'oauth',
  operating_systems = 'operating-systems',
  options = 'options',
  organization = 'organization',
  organization_details = 'organization-details',
  organizations = 'organizations',
  orgSummary = 'org-summary',
  overviewData = 'overview-data',
  metrics = 'metrics',
  packageId = 'packageId',
  packageInstanceId = 'packageInstanceId',
  packages = 'packages',
  packageAddons = 'packageAddons',
  pageId = 'pageId',
  pages = 'pages',
  monitoring_pages = 'monitoring-pages',
  openapi = 'openapi',
  page_summary = 'page-summary',
  password_reset = 'password-reset',
  pending = 'pending',
  performance = 'performance',
  permissions = 'permissions',
  permission_tree = 'permission-tree',
  portal = 'portal',
  portfolio = 'portfolio',
  populateMonitoring = 'populateMonitoring',
  populateRemediationProgress = 'populateRemediationProgress',
  possible_target_statuses = 'possible_target_statuses',
  preferences = 'preferences',
  previous = 'previous',
  previous_tokens_info = 'previous-tokens-info',
  scanning_agent = 'scanning-agent',
  task_description_for_rule = 'task-description-for-rule',
  profile = 'profile',
  programPortfolio = 'program-portfolio',
  projectId = 'projectId',
  projects = 'projects',
  projectsV2 = 'githubProjectsV2',
  projectFields = 'projectFields',
  prompt = 'prompt',
  pull = 'pull',
  push = 'push',
  public = 'public',
  quick_monitoring = 'quick-monitoring',
  quick_scan = 'quick-scan',
  rating = 'rating',
  reauthorize_connection = 'reauthorize-connection',
  refreshAccessToken = 'refreshAccessToken',
  regenerate_auth_url = 'regenerate-auth-url',
  reject = 'reject',
  registered = 'registered',
  remaining = 'remaining',
  remediatedDocumentId = 'remediatedDocumentId',
  remove = 'remove',
  removal_check = 'removal-check',
  removeRemediation = 'removeRemediation',
  revokeRemediationRequest = 'revokeRemediationRequest',
  report = 'report',
  reportId = 'reportId',
  reports = 'reports',
  requestRemediation = 'requestRemediation',
  configurableFields = 'configurable-fields',
  requiredFields = 'required-fields',
  organizationalFields = 'organizational-fields',
  rerun = 'rerun',
  resendActivationLink = 'resend-activation-link',
  resendVisitorActivationLink = 'resend-visitor-activation-link',
  resend_invite = 'resend-invite',
  resetPassword = 'resetPassword',
  resourceId = 'resourceId',
  resources = 'resources',
  restore = 'restore',
  results = 'results',
  resume = 'resume',
  resync = 'resync',
  validate = 'validate',
  role = 'role',
  roles = 'roles',
  rule = 'rule',
  ruleHistory = 'rule-history',
  ruleHistorySearch = 'rule-history-search',
  ruleId = 'ruleId',
  rule_ids = 'rule-ids',
  rules = 'rules',
  run_automated_scan = 'run-automated-scan',
  startDocumentScan = 'startDocumentScan',
  downloadReport = 'download-report',
  downloadTestReport = 'download-test-report',
  run_scan = 'run-scan',
  sauce_labs_api_key = 'sauce-labs-api-key',
  prioritization = 'prioritization',
  bulk_task_create = 'bulk-task-create',
  scan = 'scan',
  scanId = 'scanId',
  secure_resources = 'secure-download',
  setRemediation = 'set-remediation',
  scanOptionId = 'scanOptionId',
  scanSummary = 'scanSummary',
  scan_summary = 'scan-summary',
  scanTagId = 'scanTagId',
  scan_document = 'scan-document',
  scan_id = 'scanId',
  scan_results = 'scan-results',
  scan_session = 'scanSession',
  mobile_xml_scan_session = 'mobileXMLScanSession',
  mobile_scan_session = 'mobile-scan-session',
  scan_tags = 'scan-tags',
  scans = 'scans',
  page_scans = 'page-scans',
  scans_count = 'scans-count',
  scannableDocumentId = 'scannableDocumentId',
  scannableDocumentRules = 'scannableDocumentRules',
  scannableDocumentRuleId = 'scannableDocumentRuleName',
  scannableDocuments = 'scannableDocuments',
  scannableDocument = 'scannableDocument',
  scanningAgentApiKey = 'scanning-agent-api-key',
  scim = 'scim',
  scim_api_key = 'scim-api-key',
  scim_config = 'scim-config',
  scimReconciliations = 'scim-reconciliations',
  submit = 'submit',
  supplementalScan = 'supplementalScan',
  remediated = 'remediated',
  scheduled = 'scheduled',
  screens = 'screens',
  screenId = 'screenId',
  screenshot = 'screenshot',
  screenshots = 'screenshots',
  scope = 'scope',
  search = 'search',
  severity = 'severity',
  select_language = 'select-language',
  send_email = 'send-email',
  server_api_performance = 'server-api-performance',
  session = 'session',
  sessions = 'sessions',
  sessionId = 'sessionId',
  settings = 'settings',
  severities = 'severities',
  share = 'share',
  shared = 'shared',
  recipientId = 'recipientId',
  shortLink = 'shortLink',
  shortLinks = 'short-links',
  short_link = 'short-link',
  signup = 'signup',
  single_report = 'single-report',
  ssoLink = 'sso-link',
  ssoConfig = 'sso-config',
  staffGroups = 'staff-groups',
  scan_point_summary = 'scan-point-summary',
  scan_point_report = 'scan-point-report',
  standards = 'standards',
  status = 'status',
  statuses = 'statuses',
  synchronizedObjects = 'synchronized-objects',
  stream = 'stream',
  sse = 'sse',
  success = 'success',
  support = 'support',
  supported_locales = 'supported-locales',
  suspend = 'suspend',
  swagger = 'swagger',
  summary = 'summary',
  summaryKey = 'summaryKey',
  sync = 'sync',
  tags = 'tags',
  taskId = 'taskId',
  tasks = 'tasks',
  manualTracking = 'manual-tracking',
  salesforce = 'salesforce',
  tenants = 'tenants',
  tenant = 'tenant',
  tenantName = 'tenantName',
  tenantsMembership = 'tenants-membership',
  tenantId = 'tenantId',
  term = 'term',
  test_automation = 'test-automation',
  testAutomationSdks = 'sdks',
  testAutomationJavaSdk = 'java',
  testAutomationJavaMobileSdk = 'java-mobile',
  testAutomationMobileEngineIosSdk = 'mobile-engine-ios',
  testAutomationMobileEngineAndroidSdk = 'mobile-engine-android',
  testAutomationCSharpSdk = 'csharp',
  testAutomationJavascriptSdk = 'javascript',
  testAutomationPythonSdk = 'python',
  testAutomationRubySdk = 'ruby',
  toggle_rule = 'toggle-rule',
  token = 'token',
  tool = 'tool',
  tools = 'tools',
  toolName = 'toolName',
  total = 'total',
  tracking = 'tracking',
  training = `training`,
  translations = 'translations',
  type = 'type',
  types = 'types',
  ui_tools = 'ui-tools',
  unassigned_members = 'unassigned_members',
  unassigned_users = 'unassigned_users',
  unsubscribe = 'unsubscribe',
  updateEmails = 'update-emails',
  upload = 'upload',
  uploadRemediation = 'upload-remediation',
  uploadRemediationResult = 'upload-remediation-result',
  url = 'url',
  urls = 'urls',
  Users = 'Users',
  user = 'user',
  userChangeHistory = 'userChangeHistory',
  userGroups = 'user-groups',
  userId = 'userId',
  userIds = 'userIds',
  user_data = 'user-data',
  user_flows = 'user-flows',
  user_roles = 'user-roles',
  guided_user_flows = 'guided-user-flows',
  automated_user_flows = 'automated-user-flows',
  user_flow_recordings = 'user-flow-recordings',
  user_flow_templates = 'user-flow-templates',
  userFlowTemplateId = 'userFlowTemplateId',
  userFlowTemplateName = 'userFlowTemplateName',
  userFlowId = 'userFlowId',
  user_id = 'user_id',
  users = 'users',
  userway = 'userway',
  userway_site_limit_state = 'userway_site_limit_state',
  userway_sso_link = 'userway-sso-link',
  userway_account_code = 'userway-account-code',
  loginTargetAccount = 'login-target-account',
  globalUsers = 'global-users',
  verifyEmail = 'verifyEmail',
  verifyPreviousPassword = 'verify-previous-password',
  verifyPreviousPasswordVisitor = 'verify-previous-password-visitor',
  verifyResetPasswordToken = 'verifyResetPasswordToken',
  verifyToken = 'verify-token',
  verify_email = 'verify-email',
  v0 = 'v0',
  v3 = 'v3',
  videoId = `videoId`,
  videos = 'videos',
  view = 'view',
  viewDesignRule = 'view-design-rule',
  view_scan_analytics = 'view-scan-analytics',
  webhooks = 'webhooks',
  workspace = 'workspace',
  workspaceId = 'workspaceId',
  workspaceName = 'workspaceName',
  workspaceUser = 'workspaceUser',
  workspaceUserId = 'workspaceUserId',
  workspaces = 'workspaces',
  designReviews = 'design-reviews',
  designEvaluations = 'design-evaluations',
  debugLogs = 'debug-logs',
  xpath = 'xpath',
  notifications = 'notifications',
  migrate = 'migrate',
  assign = 'assign',
  withdraw_assignee = 'withdraw-assignee',
  setup_connection = 'setup-connection',
  azure = 'azure',
  jira = 'jira',
  asana = 'asana',
  github = 'github',
  gitlab = 'gitlab',
  bidirectionalSyncEligibility = 'bidirectional-sync-eligibility',
  healthCheck = 'healthcheck',
  heartbeatMetrics = 'heartbeat-metrics',
  ping = 'ping',
  important = 'important',
  assignable = 'assignable',
  mfa = 'mfa',
  labels = 'labels',
  teamSuggestions = 'team-suggestions',
  componentId = 'componentId',
  overview = 'overview',
  pdfPagesTestState = 'pdf-pages-test-state',
  startAutoRemediation = 'start-auto-remediation',
  autoRemediationState = 'auto-remediation-state',
  uploadAutoRemediatedPdf = 'upload-auto-remediated-pdf',
  autoRemediationReportByRule = 'auto-remediation-report-by-rule',
  autoRemediationRules = 'auto-remediation-rules',
  security = 'security',
  newSecurity = 'new-security',
  userManagement = 'user-management',
  accessibilityPolicies = 'accessibility-policies',
  workspaceSettings = 'workspace-settings',
  designReviewHighlights = 'design-review-highlights',
  activate = 'activate',
  designReviewHighlightId = 'designReviewHighlightId',
  components = 'components',
  pdf = 'pdf',
  pdfDiscovered = 'pdf-discovered',
  copy = 'copy',
  scannableDocumentPageId = 'scannableDocumentPageId',
  scannableDocumentPage = 'scannableDocumentPage',
  contentTags = 'content-tags',
  availableContentTags = 'avaliable-content-tags',
  availableSignupFields = 'available-signup-fields',
  data_snapshots = 'data-snapshots',
  finishOAuth2 = 'finishOAuth2',
  validateTasks = 'validate-tasks',
  websitesAndApps = 'websites-apps',
  environments = 'environments',
  jobs = 'jobs',
  continuum = 'continuum',
  continuumProjectId = 'continuumProjectId',
  incomingWebhooks = 'incoming-webhooks',
  snapshots = 'snapshots',
  taskProjectId = 'taskProjectId',
  cloudsmithToken = 'cloudsmith-token',
  dockerToken = 'docker-token',
  mobileEngineIosSdkDownload = 'mobile-engine-ios-sdk-download',
  mobileEngineAndroidSdkToken = 'mobile-engine-android-sdk-token',
  trackedProjects = 'tracked-projects',
  requests = 'requests',
  recentWorkspaces = 'recent-workspaces',
  conformanceScoreReport = 'conformance-score-report',
  conformanceScoreHistory = 'conformance-score-history',
  metadata = 'metadata',
  auditedDocuments = 'audited-documents',
  successCriteria = 'successCriteria',
  severityKey = 'severityKey',
  swapRanks = 'swap-ranks',
  deleteAndReassign = 'delete-and-reassign',
  fail = 'fail',
  scanningAgent = 'scanning-agent',
  odt = 'odt',
  v2 = 'v2',
  platform = 'platform',
  update = 'update',
  batched = 'batched',
  summaryId = 'summaryId',
  digitalAsset = 'digital-asset',
  digitalAssets = 'digital-assets',
  digitalAssetId = 'digitalAssetId',
  customize = 'customize',
  configure = 'configure',
  stats = 'stats',
  aiFilters = 'ai-filters',
  setAutomatedUserFlowError = 'set-automated-user-flow-error',
  aiWorkflows = 'ai-workflows',
  mobileCrawler = 'mobile-crawler',
  accessibilityTest = 'accessibility-test',
  figmaPlugin = 'figma-plugin',
  downloadPlugin = 'download-plugin',
  loginPlugin = 'login-plugin',
  runAuditPlugin = 'run-audit-plugin',
  expandFindingPlugin = 'expand-finding-plugin',
  locateFindingPlugin = 'locate-finding-plugin',
  figmaPluginAnnotation = 'figma-plugin-annotation',
  figmaPluginCompanionAccessibilityNotes = 'figma-plugin-companion-accessibility-notes',
  figmaPluginAltText = 'figma-plugin-alt-text',
  figmaPluginFocusOrder = 'figma-plugin-focus-order',
  figmaPluginAltTextFrameAnalysis = 'figma-plugin-alt-text-frame-analysis',
  figmaPluginCompletion = 'figma-plugin-completion',
  figmaPluginContrastRecommendation = 'figma-plugin-contrast-recommendation',
  ruleMatch = 'rule-match',
  featureFlags = 'feature-flags',
  tenantFeatureFlags = 'tenant-feature-flags',
  featureManagement = 'feature-management',
  saveIdentity = 'save-identity',
  rewrite = 'rewrite',
  bullBoard = 'bull-board',
  instrument = 'instrument',
  dynamicMapping = 'dynamic-mapping',
  vpatReport = 'vpat-report',
  scopingCrawl = 'scoping-crawl',
  scoping = 'scoping',
  scopingPageRecommendation = 'scoping-page-recommendation',
  startEvaluation = 'start-evaluation',
  exportScope = 'export-scope',
  appIdentifier = 'appIdentifier',
  regenerate = 'regenerate',
  turns = 'turns',
  rotate = 'rotate',
  schedule = 'schedule',
  ztFix = 'zt-fix',
  ztFixSetup = 'setup',
  ztFixAccess = 'access',
  ztFixDataConsent = 'data-consent',
  ztFixTermsConsent = 'terms-consent',
  events = 'events',
  downloads = 'downloads',
  os = 'os',
  arch = 'arch',
}

export enum ApiQueryOption {
  cursor = 'cursor',
  eventType = 'eventType',
  grouped = 'grouped',
  notificationId = 'notificationId',
  pageUrl = 'pageUrl',
  search = 'search',
  userId = 'userId',
  addFlag = 'addFlag',
  audit = 'audit',
  audits = 'audits',
  auditType = 'auditType',
  auditTool = 'auditTool',
  avatarToken = 'avatarToken',
  category = 'category',
  clientSearchTerm = 'clientSearchTerm',
  componentId = 'componentId',
  confirmEmailToken = 'confirmEmailToken',
  createdAt = 'createdAt',
  direction = 'direction',
  downloadReport = 'downloadReport',
  downloadToken = 'downloadToken',
  designReviewFindingId = 'designReviewFindingId',
  email = 'email',
  evaluationIdsKey = 'evaluationIdsKey',
  errorXPath = 'errorXPath',
  excludeForPredefinedRoles = 'excludeForPredefinedRoles',
  excludeSelf = 'excludeSelf',
  externalId = 'externalId',
  includeStaffUsers = 'includeStaffUsers',
  filter = 'filter',
  filterLegacyEA = 'filterLegacyEA',
  filterByUserId = 'filterByUserId',
  finding = 'finding',
  findingId = 'findingId',
  flawId = 'flawId',
  format = 'format',
  frequency = 'frequency',
  fromDate = 'fromDate',
  jobStatus = 'jobStatus',
  id = 'id',
  identifier = 'identifier',
  includeDisabled = 'includeDisabled',
  includeRules = 'includeRules',
  includeIgnored = 'includeIgnored',
  includeStaffGroups = 'includeStaffGroups',
  searchTerm = 'searchTerm',
  skipOrganizationAdmin = 'skipOrganizationAdmin',
  includeMe = 'includeMe',
  issueIds = 'issueIds',
  issueType = 'issueType',
  lastUsedWorkspace = 'lastUsedWorkspace',
  languageForScanning = 'languageForScanning',
  level = 'level',
  limit = 'limit',
  pageSize = 'pageSize',
  linkedPropertyData = 'linkedPropertyData',
  lightweight = 'lightweight',
  myContacts = 'myContacts',
  name = 'name',
  resultsCompression = 'resultsCompression',
  pageScore = 'pageScore',
  pathRoot = 'pathRoot',
  queryString = 'queryString',
  resourceId = 'resourceId',
  ruleId = 'ruleId',
  ruleDescription = 'ruleDescription',
  salesforceId = 'salesforceId',
  scanUrl = 'scanUrl',
  scanId = 'scanId',
  scanFromDate = 'scanFromDate',
  scanningType = 'scanningType',
  scanToDate = 'scanToDate',
  scanPointId = 'scanPointId',
  skip = 'skip',
  page = 'page',
  sortByName = 'title',
  sortCreatedAt = 'createdAt',
  sortCreatedBy = 'createdBy',
  sortByDigitalProperty = 'digitalProperty',
  sortBy = 'sortBy',
  sortDirection = 'sortDirection',
  sortOrder = 'sortOrder',
  source = 'source',
  status = 'status',
  severity = 'severity',
  standards = 'standards',
  successCriteria = 'successCriteria',
  switchToWorkspace = 'switchToWorkspace',
  tenantlessOnly = 'tenantlessOnly',
  tool = 'tool',
  toolName = 'toolName',
  toolVersion = 'toolVersion',
  topic = 'topic',
  term = 'term',
  totalFinding = 'totalFinding',
  trendDataLength = 'trendDataLength',
  url = 'url',
  urls = 'urls',
  userIds = 'userIds',
  ids = 'ids',
  workspace = 'workspace',
  workspaceId = 'workspaceId',
  workspaceIds = 'workspaceIds',
  withSummary = 'with-summary',
  integrationType = 'integrationType',
  lastId = 'lastId',
  fieldName = 'fieldName',
  query = 'query',
  documentIds = 'documentIds',
  origin = 'origin',
  entityLevel = 'entityLevel',
  excludeGroupIds = 'excludeGroupIds',
  securityGroupId = 'securityGroupId',
  isStaffGroup = 'isStaffGroup',
  isServiceGroup = 'isServiceGroup',
  inviteStatus = 'inviteStatus',
  pages = 'pages',
  pageIds = 'pageIds',
  tenantId = 'tenantId',
  toolId = 'toolId',
  tags = 'tags',
  important = 'important',
  hasScope = 'hasScope',
  oauth2AuthorizationResult = 'oauth2AuthorizationResult',
  authorizationResult = 'authorizationResult',
  archive = 'archive',
  digitalPropertyId = 'digitalPropertyId',
  digitalPropertyIds = 'digitalPropertyIds',
  riskScoreLevel = 'riskScoreLevel',
  scheduledAt = 'scheduledAt',
  showSuccessAlert = 'showSuccessAlert',
  allFields = 'allFields',
  recordingId = 'recordingId',
  regenerate = 'regenerate',
  from = 'from',
  to = 'to',
  manualRequestResult = 'manualRequestResult',
  standard = 'standard',
  useScanningAgent = 'useScanningAgent',
  typeIds = 'typeIds',
  issueTrackingCallback = 'issueTrackingCallback',
  issueTrackingConnectionId = 'issueTrackingConnectionId',
  resume = 'resume',
  hasAutomatedRemediation = 'hasAutomatedRemediation',
  conformanceLevel = 'conformanceLevel',
  deviceType = 'deviceType',
  includeArchived = 'includeArchived',
  snapshotsLimit = 'snapshotsLimit',
  domain = 'domain',
  recordEvent = 'recordEvent',
  dataLevel = 'dataLevel',
  entityId = 'entityId',
  dataSource = 'dataSource',
  withAction = 'withAction',
  mobileOnly = 'mobileOnly',
  target = 'target',
  userwayAccountCode = 'userwayAccountCode',
  userwayFailureRedirectUri = 'userwayFailureRedirectUri',
  userwayState = 'userwayState',
  state = 'state',
  callerOrigin = 'callerOrigin',
  sessionId = 'sessionId',
  requestId = 'requestId',
  redirectToSso = 'redirectToSso',
  customReportExportKey = 'customReportExportKey',
  vpatType = 'vpatType',
  fromBackgroundScan = 'fromBackgroundScan',
  tagId = 'tagId',
  includePageDetails = 'includePageDetails',
}

export enum ApiHeaderOption {
  skipLoader = 'skipLoader',
}

export const ApiQueryOptionValue: Readonly<{ [key: string]: any }> = Object.freeze({
  true: true,
  false: false,
});
